// Pinned, scroll-driven horizontal reveal for the Eos/Hera/Serena showcase.
// Respects prefers-reduced-motion by falling back to a normal stacked layout.
(function () {
  'use strict';

  document.querySelectorAll('[data-collections-scroll]').forEach(function (wrap) {
    var row = wrap.querySelector('.collections-row');
    var dots = Array.prototype.slice.call(wrap.querySelectorAll('.collections-dots span'));
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!row) return;

    if (reduceMotion) {
      wrap.classList.add('no-scrolly');
      return;
    }

    var panelCount = row.children.length;
    var ticking = false;

    var update = function () {
      ticking = false;
      var rect = wrap.getBoundingClientRect();
      var scrollable = wrap.offsetHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var progress = Math.max(0, Math.min(1, (-rect.top) / scrollable));
      var maxShift = (panelCount - 1) * window.innerWidth;
      row.style.transform = 'translateX(' + (-progress * maxShift) + 'px)';
      var activeIdx = Math.round(progress * (panelCount - 1));
      dots.forEach(function (dot, i) { dot.classList.toggle('active', i === activeIdx); });
    };

    var onScroll = function () {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    update();
  });
})();
